export const environment = {
  production: true,
  baseurl: "https://sluper.bio/api/bizConnect/public",
  baseurlLoginProfile: "https://perfil.sluper.bio/login/"
};
